import { useState } from "react"
import { HiArrowRightOnRectangle } from "react-icons/hi2"
import { Button } from "~/components/ui/button"
import { LogoutConfirmDialog } from "~/features/auth/components/logout-confirm-dialog"

export function LogoutButton() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="overlay-icon"
        size="icon-sm"
        onClick={() => setOpen(true)}
      >
        <HiArrowRightOnRectangle />
      </Button>
      <LogoutConfirmDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
